import { baseApi } from "./baseApi";

const METRIC_BASE_URL = "/metrics";

export const metricApi = baseApi.injectEndpoints({
  tagTypes: ["Metric"],

  endpoints: (builder) => ({
    listMetrics: builder.query({
      query: (params) => ({ url: METRIC_BASE_URL, params }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({ type: "Metric", _id })),
              { type: "Metric", id: "LIST" },
            ]
          : [{ type: "Metric", id: "LIST" }],
    }),
  }),
});

export const { useListMetricsQuery, useLazyListMetricsQuery } = metricApi;
